import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/react-router'
import { Button } from 'ui/button'

import { NoGuessedTextGenerator } from '~/boundedContext/cards/components/no-guessed-text-generator'
import { useCardsGameStore } from '~/stores/cards-game'

export const NoCardsInStack = () => {
  const { t } = useTranslation()
  const notGuessedCards = useCardsGameStore(state => state.notGuessedCards)
  const reset = useCardsGameStore(state => state.reset)
  const navigate = useNavigate()

  return (
    <div className="mx-auto flex h-full w-11/12 max-w-sm flex-col justify-end gap-4">
      <NoGuessedTextGenerator />
      <Button
        onClick={() => {
          reset()
          void navigate({ to: '/cards' })
        }}
      >
        {t('Repeat Stack')}
      </Button>
      <Button
        onClick={() => {
          reset(notGuessedCards)
          void navigate({ to: '/cards' })
        }}
      >
        {t('Review Unknown')}
      </Button>
    </div>
  )
}
